import InteractiveTileConfig from '../classes/InteractiveTileConfig'

export default function createEmptyGrid({
  minX,
  maxX,
  minY,
  maxY,
}: {
  minX: number
  maxX: number
  minY: number
  maxY: number
}) {
  // creates the matrix with the dimensions from tiles
  // + 1 is to include position 0 in the arrays. If the diff between min and max is 1, then we need 2 an array of 2 positions
  const interactiveGrid: InteractiveTileConfig[][] = Array(Math.abs(minY - maxY) + 1)
    .fill(0)
    .map(() =>
      Array(Math.abs(minX - maxX) + 1)
        .fill(0)
        .map(() => new InteractiveTileConfig(-1, -1)),
    )
  return interactiveGrid
}
